export const UPDATE_CRITERIA_TAB = ' UPDATE_CRITERIA_TAB';
export const UPDATE_NSLCDATA_TAB = 'UPDATE_NSLCDATA_TAB';
export const RESET_FROM_CRITERIA_TAB = 'RESET_FROM_CRITERIA_TAB'
